type NamedPlayer = { firstName: string; lastName?: string | null };

/**
 * Volledige naam van een speler.
 *
 * De achternaam is optioneel - een speler die alleen als voornaam bekend staat wordt met
 * een lege achternaam opgeslagen. Zonder deze helper levert de gebruikelijke interpolatie
 * dan "Julia " op, met een losse spatie in tooltips, labels en sorteersleutels.
 */
export function playerFullName(player: NamedPlayer): string {
  return `${player.firstName} ${player.lastName ?? ''}`.trim();
}

/**
 * Initialen voor de avatar. Bij een lege achternaam blijft alleen de voorletter over.
 */
export function playerInitials(player: NamedPlayer): string {
  return `${player.firstName.charAt(0)}${(player.lastName ?? '').charAt(0)}`;
}

/**
 * Hoe een speler op de publieke pagina's heet: alleen de voornaam. Het gaat vaak om
 * minderjarigen, en een deel-link gaat rond in appgroepen. De publieke API stuurt de
 * achternaam ook niet mee; dit is waar de pagina's dat zichtbaar maken.
 */
export function publicPlayerName(player: NamedPlayer): string {
  return player.firstName;
}
